import anime from 'animejs'
import { controller, handleReturn, resetForm } from '../form'

let popup
let close
let form
let content
let escapeLogo
let tick

let emailInput
let consent

let tickAnimation

let tmpTrigger

let controllerObj

export function Newsletter() {
    popup = document.querySelector('.js-newsletter-popup')

    if (!popup) {
        return
    }

    close = popup.querySelector('.js-newsletter-close')
    form = popup.querySelector('.js-newsletter-form')
    tick = popup.querySelector('.js-newsletter-tick')
    escapeLogo = popup.querySelector('.js-newsletter-escape')
    tmpTrigger = document.querySelector('.js-newsletter-open-btn')
    content = popup.querySelector('.js-newsletter-content')

    emailInput = form.querySelector('[id=email]')
    consent = form.querySelector('[id=consent]')

    controllerObj = controller(form, handleForm)

    tmpTrigger.addEventListener('click', () => {
        popup.showModal()
    })

    tickAnimation = anime({
        targets: tick,
        strokeDashoffset: [anime.setDashoffset, 0],
        direction: 'reverse',
        easing: 'easeInOutCubic',
        duration: 900
    })

    popup.addEventListener('click', (evt) => {
        if (evt.target.tagName === 'INPUT') {
            return
        }

        if (evt.target.classList.contains('js-newsletter-close')) {
            evt.preventDefault()
            popup.close()
            return
        }

        if (
            evt.offsetX < 0 ||
            evt.offsetX > evt.target.offsetWidth ||
            evt.offsetY < 0 ||
            evt.offsetY > evt.target.offsetHeight
        ) {
            popup.close()
        }
    })

    form.addEventListener('submit', (evt) => {
        evt.preventDefault()
        toggleTick()
    })

    consent.addEventListener('change', toggleTick)
    emailInput.addEventListener('change', toggleTick)
}

function toggleTick() {
    if (emailInput.value && consent.checked && !escapeLogo.classList.contains('is-active')) {
        openTick()
    } else if (
        (!emailInput.value || !consent.checked) &&
        escapeLogo.classList.contains('is-active')
    ) {
        closeTick()
    }
}

function closeTick() {
    escapeLogo.classList.remove('is-active')
    tickAnimation.reverse()
    tickAnimation.play()
}

function openTick() {
    escapeLogo.classList.add('is-active')
    tickAnimation.reverse()
    tickAnimation.play()
}

function handleForm({ data }) {
    if (!data) {
        return
    }

    if (!data.success) {
        handleReturn.call(controllerObj, { data })
        return
    }

    resetForm.call(controllerObj)
    form.reset()

    if (data.trackingEvent && typeof ga === 'function') {
        const trackers = ga.getAll()
        if (trackers.length) {
            const trackerName = trackers[0].get('name')
            ga(trackerName + '.send', 'event', data.trackingEvent)
        }
    }

    if (data.redirect) {
        window.location.href = data.redirect
        return
    }

    form.classList.add('hide-form')

    if (data.message) {
        content.innerHTML = data.message
    }
}
